import { t } from "./i18n";
import { pushLayer } from "./history_stack";

// a full screen picture with a few buttons under it. tap outside it, press escape or use close to leave

export interface LightboxAction {
  label: string;
  accent?: boolean;
  run: () => void;
}

export function openLightbox(src: string, actions: LightboxAction[] = []): void {
  const modal = document.createElement("div");
  modal.className = "modal lightbox";
  const frame = document.createElement("div");
  frame.className = "lightbox-frame";
  const image = document.createElement("img");
  image.className = "feed-lightbox-image";
  image.src = src;
  image.alt = "";
  const keys = document.createElement("div");
  keys.className = "row lightbox-keys";
  const hide = () => {
    document.removeEventListener("keydown", onKey);
    modal.remove();
  };
  const release = pushLayer(hide);
  const close = () => {
    hide();
    release();
  };
  const onKey = (event: KeyboardEvent) => {
    if (event.key === "Escape") close();
  };
  for (const action of [...actions, { label: t("close"), run: () => undefined }]) {
    const button = document.createElement("button");
    button.type = "button";
    button.className = `pill${action.accent ? " accent" : ""}`;
    button.textContent = action.label;
    button.addEventListener("click", () => {
      close();
      action.run();
    });
    keys.append(button);
  }
  modal.addEventListener("click", (event) => {
    if (event.target === modal) close();
  });
  document.addEventListener("keydown", onKey);
  frame.append(image, keys);
  modal.append(frame);
  document.body.append(modal);
}
